// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import lbrEntity from './entities/lbr.json';
import lbrMenu from '../pages/lbr/menu.json';
import lbrFullForm from '../pages/lbr/forms/full.json';
import lbrContextForm from '../pages/lbr/forms/context.json';
import lbrMiniForm from '../pages/lbr/forms/mini.json';
import lbrLookupForm from '../pages/lbr/forms/lookup.json';
import lbrTableView from '../pages/lbr/views/table.json';
import lbrStagesView from '../pages/lbr/views/stages.json';
import lbrCardsView from '../pages/lbr/views/cards.json';
import lbrInlineView from '../pages/lbr/views/inline.json';
import lbrBacklogView from '../pages/lbr/views/backlog.json';
import lbrSplitView from '../pages/lbr/views/split.json';
import lbrCalendarView from '../pages/lbr/views/calendar.json';
import lbrDashboardView from '../pages/lbr/views/dashboard.json';

/** Тип запису «Організація» зі сторінками пакета: меню, форми та подання з pages/lbr/. */
export const lbrDefinition: IRecordTypeDefinition = {
  ...lbrEntity,
  views: assembleViewSet({
      table: lbrTableView,
      stages: lbrStagesView,
      cards: lbrCardsView,
      inline: lbrInlineView,
      backlog: lbrBacklogView,
      split: lbrSplitView,
      calendar: lbrCalendarView,
      dashboard: lbrDashboardView,
  }),
  form: lbrFullForm,
  forms: { full: lbrFullForm, context: lbrContextForm, mini: lbrMiniForm, lookup: lbrLookupForm },
  menu: lbrMenu,
} as IRecordTypeDefinition;
